/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  organizationContainer: {
    position: "fixed",
    flexGrow: 1,
    overflow: "hidden",
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(1),
    width: '100%',
    backgroundColor: theme.palette.background.default,
  },
  isIframe: {
    // marginLeft: theme.spacing(1.5)
  },
  organizationHeader: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.background.default,
  },
  orgTitle: {
    padding: theme.spacing(2),
    fontWeight: 700,
    fontSize: theme.spacing(2.5),
    color: theme.palette.text.primary,
  },
  orgHeaderTitle: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  organizationDetailsWrap: {
    width: "100%",
    borderWidth: 1,
    height: "90vh",
    borderStyle: "solid",
    borderRadius: theme.spacing(0.5),
    borderColor: theme.palette.grey[300],
    overflow: "hidden",
    backgroundColor: theme.palette.background.default
  },
  threeDotMenu: {
    width: theme.spacing(6),
  },
  menuActionWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  menuItemText: {
    marginLeft: theme.spacing(1.5),
  },
  headerText: {
    ZIndex: 1,
    fontWeight: 500,
    fontSize: theme.spacing(3),
    lineHeight: theme.spacing(3.5),
    color: theme.palette.text.primary,
  },
  organizatonInput: {
    width: theme.spacing(50),
  },
  organizationInput: {
    width: theme.spacing(50),
  },
  organizationHeaderTitleWrap: {
    display: "flex",
    alignItems: "center",
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    }
  },
  organizationHeaderText: {
    ZIndex: 1,
    fontWeight: 500,
    fontSize: theme.spacing(2),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: theme.spacing(120),
    lineHeight: theme.spacing(3.5),
    color: theme.palette.text.primary,
  },
  headerRightWrap: {
    display: "flex",
    alignItems: "center",
  },
  detailsBox: {
    alignItems: "center",
    display: "flex",
    // backgroundColor: "#F6F7FA",
  },
  detailsBoxItems: {
    alignItems: "center",
    paddingLeft: theme.spacing(3),
    display: "flex",
  },
  appBar: {
    width: "194px",
  }
}));
